import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import {
    defaultMergeRequestsParams,
    mergeRequestsParamsSchema,
} from './-SearchParams';
import { MergeFilters } from './-Filters';
import { MergeRequestsTable } from './-MergeRequestsTable';
import { mergesQuery } from '~/util/queries/staff/merges';

export const Route = createFileRoute('/_authenticated/staff/_mergesLayout/merges/')({
    validateSearch: mergeRequestsParamsSchema,
    search: {
        middlewares: [stripSearchParams(defaultMergeRequestsParams)],
    },
    loaderDeps: ({ search: { status, page, per_page } }) => ({
        status,
        page,
        per_page,
    }),
    loader: async ({ deps: filters, context: { queryClient } }) =>
        await queryClient.fetchQuery(mergesQuery(filters)),
    component: RouteComponent,
    pendingMs: 3000,
});

function RouteComponent() {
    return (
        <div>
            <MergeFilters />
            <MergeRequestsTable />
        </div>
    );
}
